// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__R0ca3","container":"SectionFaq_container__qlzTd","faq__title":"SectionFaq_faq__title__phgaT","faq__list-container":"SectionFaq_faq__list-container__cmLBY"};